<ng-container>
	<img src="/assets/images/cloud-no-notifications.svg" alt="not found image" width="65" height="105">
	<p id="notifications-not-found" class="zk-pb-4" freud-typography fontType="h6Regular1-5">
		{{ 'NOTIFICATIONS.CARD.NOT_FOUND' | translate }}
	</p>
</ng-container>